module.exports = __webpack_public_path__ + "img/Angola.d9c8637d.png";